var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOctoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-octoIcon"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 140
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "octoIcon",
    clipPath: "url(#clip-octoIcon)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M19.1,102.1c9.4-6,20.3-16.3,16.2-28.5C33,67,29.9,61.3,29.5,54.2a43.554,43.554,0,0,1,2.6-17.9C40.5,13.8,65.4,3.2,87.9,10c20.8,6.3,35.2,30.5,26.6,51.6-5,12.2-7.2,21.6,3.9,31,3,2.6,10.3,6.4,10.3,11,0,6-11.7-1.3-13-2.3,1.5,2.6,16.2,18,6.8,19.1-8.6,1-16.3-11.1-21.5-16.2-8.7-8.7-7.2,10.6-7.2,14.5-.1,6.3-4.5,19-12.5,10.7-6.6-6.8-4.1-17.8-8.7-25.4-5-8.3-13.3,8.3-15.4,11.4-2.3,3.4-14,19.9-18.6,11.1-3.8-7.1,2.2-18.3,5.2-24.8-1.1,2.3-8.7,5.8-10.9,6.9-5,2.5-10.1,4.1-15.8,3.7-11.7-.8-2.7-7,2-10.2Z",
    transform: "translate(-0.345 0.036)",
    fill: "#0d80d8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOctoIcon);
export default __webpack_public_path__ + "static/media/octoIcon.fe5b7d9e.svg";
export { ForwardRef as ReactComponent };